import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

class ContentPreviewModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			loading: false,
			error: null,
			mediaContents: [],
			currentMediaIndex: 0
		}
	}

	componentDidMount() {
		this.fetchMediaContents()
	}

	fetchMediaContents = () => {
		const { event } = this.props

		// First check if there's media in the event
		if (event.tracker && event.tracker.media) {
			this.setState({ loading: true, error: null })
			this.fetchMediaContent(event.tracker.media)
		}

		// Then check if there's media in whatsApp conversation
		if (event.tracker && event.tracker.whatsAppConversation &&
			event.tracker.whatsAppConversation.mediaList &&
			event.tracker.whatsAppConversation.mediaList.length > 0) {

			this.setState({ loading: true, error: null })

			// Fetch each media item from the mediaList
			const mediaList = event.tracker.whatsAppConversation.mediaList
			mediaList.forEach(media => {
				if (media.url) {
					this.fetchMediaFromUrl(media.url, media.type)
				}
			})
		}
	}

	fetchMediaContent = (mediaPath) => {
		if (!mediaPath) {
			console.error('No media path provided')
			return
		}

		console.log(`Fetching media content, path: ${mediaPath}`)
		
		this.setState({ loading: true, error: null })
		
		const payload = {
			path: mediaPath
		}

		RestApiUtils.post(
			this.props.context,
			'/api/s3/preview',
			this.handleMediaResponse,
			// this.handleMediaError,
			payload
		)
	}

	fetchMediaFromUrl = (url, type) => {
		// For external URLs, we can just add them directly to our media list
		const newMedia = {
			url: url,
			type: type || this.getMediaTypeFromUrl(url),
			name: this.getFileNameFromUrl(url)
		}

		this.setState(prevState => ({
			mediaContents: [...prevState.mediaContents, newMedia],
			loading: false
		}))
	}

	getMediaTypeFromUrl = (url) => {
		if (!url) return 'unknown'

		const extension = url.split('.').pop().toLowerCase()

		if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) return 'image'
		if (['mp4', 'mov', 'avi', 'webm'].includes(extension)) return 'video'
		if (['pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt'].includes(extension)) return 'document'

		return 'unknown'
	}

	getFileNameFromUrl = (url) => {
		if (!url) return 'unknown'
		return url.split('/').pop()
	}

	handleMediaResponse = (response) => {
		console.log('Media API response:', response)
		if (response && response.success === 'success' && response.signedUrl) {
			const { signedUrl, path } = response
			console.log('Got signed URL:', signedUrl)

			// Determine the type of media from the path
			const type = this.getMediaTypeFromUrl(path)
			const name = this.getFileNameFromUrl(path)

			const newMedia = {
				url: signedUrl,
				type,
				name,
				path
			}

			this.setState(prevState => ({
				mediaContents: [...prevState.mediaContents, newMedia],
				loading: false
			}))
		} else {
			console.error('Failed to get media preview URL', response)
			this.setState({
				loading: false,
				error: 'Failed to get media URL'
			})
		}
	}

	handleMediaError = (error) => {
		console.error('Error fetching media:', error)
		this.setState({
			loading: false,
			error: 'Failed to fetch media content'
		})
	}

	handleDownload = (media) => {
		if (!media || !media.url) return

		// Create an anchor element and trigger download
		const link = document.createElement('a')
		link.href = media.url
		link.download = media.name || 'download'
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	}

	handlePrevious = () => {
		this.setState(prevState => ({
			currentMediaIndex: Math.max(0, prevState.currentMediaIndex - 1)
		}))
	}

	handleNext = () => {
		this.setState(prevState => ({
			currentMediaIndex: Math.min(
				prevState.mediaContents.length - 1,
				prevState.currentMediaIndex + 1
			)
		}))
	}

	renderMediaContent = (media) => {
		if (!media) return <div className="no-media">No media content available</div>

		switch (media.type) {
			case 'image':
				return (
					<div className="media-container image">
						<img src={media.url} alt={media.name || 'Image preview'} />
					</div>
				)
			case 'video':
				return (
					<div className="media-container video">
						<video controls src={media.url} className="video-player">
							Your browser does not support the video tag.
						</video>
					</div>
				)
			case 'document':
				// For PDFs, we can use an iframe
				if (media.name && media.name.toLowerCase().endsWith('.pdf')) {
					return (
						<div className="media-container document">
							<iframe
								src={`${media.url}#toolbar=0&navpanes=0`}
								className="pdf-viewer"
								title="PDF Preview"
							/>
						</div>
					)
				}
				// For other documents, show a download prompt
				return (
					<div className="media-container document">
						<div className="document-info">
							<i className="icon-file-text2"></i>
							<span>{media.name || 'Document'}</span>
							<p>This document cannot be previewed. Please download to view.</p>
						</div>
					</div>
				)
			default:
				return (
					<div className="media-container unknown">
						<div className="document-info">
							<i className="icon-file-empty"></i>
							<span>{media.name || 'Unknown file'}</span>
							<p>This file type is not supported for preview. Please download to view.</p>
						</div>
					</div>
				)
		}
	}

	render() {
		const { onClose } = this.props
		const { loading, error, mediaContents, currentMediaIndex } = this.state
		const currentMedia = mediaContents[currentMediaIndex]
		const hasMultipleMedia = mediaContents.length > 1

		return (
			<div className="content-preview-modal-overlay">
				<div className="content-preview-modal">
					<div className="content-preview-modal-header">
						<div className="content-preview-modal-title">
							<span>Content Preview</span>
							{currentMedia && (
								<span className="media-counter">
									{currentMediaIndex + 1} of {mediaContents.length}
								</span>
							)}
						</div>
						<button className="close-button" onClick={onClose}>×</button>
					</div>

					<div className="content-preview-modal-body">
						{loading && <SpinnerComponentUI />}

						{!loading && error && (
							<div className="error-message">{error}</div>
						)}

						{!loading && mediaContents.length === 0 && !error && (
							<div className="no-media-message">No media content found</div>
						)}

						{!loading && currentMedia && this.renderMediaContent(currentMedia)}

						{hasMultipleMedia && (
							<div className="media-navigation">
								<button
									className="nav-button prev"
									onClick={this.handlePrevious}
									disabled={currentMediaIndex === 0}
								>
									←
								</button>
								<button
									className="nav-button next"
									onClick={this.handleNext}
									disabled={currentMediaIndex === mediaContents.length - 1}
								>
									→
								</button>
							</div>
						)}
					</div>

					<div className="content-preview-modal-footer">
						{currentMedia && (
							<button
								className="download-button"
								onClick={() => this.handleDownload(currentMedia)}
							>
								Download
							</button>
						)}
					</div>
				</div>
			</div>
		)
	}
}

export default ContentPreviewModal
